import { isEaseTheme } from '@/config/designSystem'

const Footer = () => {
  if (isEaseTheme()) {
    return (
      <footer className="border-t border-eh-border bg-eh-cream pb-8 pt-14">
        <div className="eh-container">
          <div className="grid grid-cols-1 gap-[42px] md:grid-cols-2 lg:grid-cols-[1.5fr_repeat(3,1fr)]">
            <div>
              <h3 className="font-display text-lg text-eh-forest-ink">Trung tâm M2MBA</h3>
              <p className="footer-note mt-4 max-w-[260px] text-xs leading-relaxed text-[#646a65]">
                Đăng ký ngay những khóa học chất lượng, được thiết kế để phát triển kỹ năng và tăng
                tốc con đường sự nghiệp của bạn.
              </p>
            </div>
            <div>
              <h3 className="mb-3.5 text-[11px] font-semibold uppercase tracking-[0.08em] text-eh-forest-ink">
                Liên kết nhanh
              </h3>
              <ul className="grid gap-2">
                <li>
                  <a href="/courses" className="text-sm text-eh-muted hover:text-eh-forest-ink hover:underline">
                    Khám phá khóa học
                  </a>
                </li>
                <li>
                  <a href="/about" className="text-sm text-eh-muted hover:text-eh-forest-ink hover:underline">
                    Về chúng tôi
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-sm text-eh-muted hover:text-eh-forest-ink hover:underline">
                    Liên hệ
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="mb-3.5 text-[11px] font-semibold uppercase tracking-[0.08em] text-eh-forest-ink">
                Hỗ trợ
              </h3>
              <ul className="grid gap-2">
                <li>
                  <a href="/terms-of-service" className="text-sm text-eh-muted hover:text-eh-forest-ink hover:underline">
                    Điều khoản dịch vụ
                  </a>
                </li>
                <li>
                  <a href="/security-policy" className="text-sm text-eh-muted hover:text-eh-forest-ink hover:underline">
                    Chính sách bảo mật
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="mb-3.5 text-[11px] font-semibold uppercase tracking-[0.08em] text-eh-forest-ink">
                Học tập
              </h3>
              <ul className="grid gap-2">
                <li>
                  <a href="/skills" className="text-sm text-eh-muted hover:text-eh-forest-ink hover:underline">
                    Thư viện
                  </a>
                </li>
                <li>
                  <a href="/blog" className="text-sm text-eh-muted hover:text-eh-forest-ink hover:underline">
                    Blog
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-14 flex flex-col justify-between gap-5 border-t border-eh-border pt-5 text-[10px] text-[#6a706a] sm:flex-row">
            <p>© {new Date().getFullYear()} Trung tâm M2MBA. Bản quyền thuộc về chúng tôi.</p>
            <p>Ease Health design system</p>
          </div>
        </div>
      </footer>
    )
  }

  return (
    <footer className="border-t border-m2-outline-variant bg-m2-surface-lowest">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
            <div className="col-span-1 md:col-span-2">
              <h3 className="mb-4 font-headline text-lg font-semibold text-m2-on-surface">
                Trung tâm M2MBA
              </h3>
              <p className="max-w-md text-m2-on-surface-variant">
                Đăng ký ngay những khóa học chất lượng, được thiết kế để phát triển kỹ năng và tăng
                tốc con đường sự nghiệp của bạn.
              </p>
            </div>
            <div>
              <h3 className="mb-4 font-label text-sm font-semibold uppercase tracking-wider text-m2-on-surface">
                Liên kết nhanh
              </h3>
              <ul className="space-y-2">
                <li>
                  <a href="/courses" className="text-m2-on-surface-variant hover:text-m2-primary">
                    Khám phá khóa học
                  </a>
                </li>
                <li>
                  <a href="/about" className="text-m2-on-surface-variant hover:text-m2-primary">
                    Về chúng tôi
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-m2-on-surface-variant hover:text-m2-primary">
                    Liên hệ
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="mb-4 font-label text-sm font-semibold uppercase tracking-wider text-m2-on-surface">
                Hỗ trợ
              </h3>
              <ul className="space-y-2">
                <li>
                  <a href="/terms-of-service" className="text-m2-on-surface-variant hover:text-m2-primary">
                    Điều khoản dịch vụ
                  </a>
                </li>
                <li>
                  <a href="/security-policy" className="text-m2-on-surface-variant hover:text-m2-primary">
                    Chính sách bảo mật
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 border-t border-m2-outline-variant pt-8">
            <p className="text-center text-sm text-m2-on-surface-variant">
              © {new Date().getFullYear()} Trung tâm M2MBA. Bản quyền thuộc về chúng tôi..
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
